import {
    DEALERGETSUMMARYMASTERLIST_SUCCESS,
    DEALERGETSUMMARYMASTERLIST_FAILED,
    RESET_DEALERGETSUMMARYMASTERLIST,
    LOADING_DEALERGETSUMMARYMASTERLIST,
    NETWORK_ERROR_DEALERGETSUMMARYMASTERLIST
} from '../types/index'

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERGETSUMMARYMASTERLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERGETSUMMARYMASTERLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERGETSUMMARYMASTERLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERGETSUMMARYMASTERLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERGETSUMMARYMASTERLIST:
            return (state = initialState);
        default:
            return state;
    }
};